import React from 'react';
import { Card } from '../../../../../../CommonComponents/OPL/Card/Card';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';
import { ModalBody } from '../../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalCloseButton } from '../../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { Stat } from '../../../../../../CommonComponents/OPL/Stat/Stat';
import {
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
  TableTitle,
  TableWrapper,
} from '../../../../../../CommonComponents/OPL/Table/Table';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { Institution } from '../../useManageLinks';
import { AggregatorIdDTO } from '../../../../api/useLinksQuery';

const AGGREGATOR_NAME_MAP: Record<AggregatorIdDTO, string> = {
  [AggregatorIdDTO.Plaid]: 'Plaid',
  [AggregatorIdDTO.Akoya]: 'Akoya',
};

interface Props {
  institution: Institution | null;
  onClose: () => void;
}

export const DetailsModal: React.FC<Props> = ({ institution, onClose }) => {
  if (!institution) {
    return null;
  }

  const aggregatorName =
    institution.DataAggregatorId !== null
      ? AGGREGATOR_NAME_MAP[institution.DataAggregatorId]
      : null;

  return (
    <Modal isOpen onRequestClose={onClose}>
      <ModalHeader>{aggregatorName ? `${aggregatorName} ` : ''}Support Details</ModalHeader>
      <ModalCloseButton onClick={onClose} />
      <ModalBody>
        <Card py={6} px={24} my={16}>
          <Stat label="item id" value={institution.ExternalLinkId} size="small" />
        </Card>

        <TableWrapper>
          <TableTitle>
            <Text fontWeight={600} fontSize="h6">
              Details
            </Text>
          </TableTitle>
          <TableHeader>
            <TableRow noBorder>
              <TableCell width="65%">
                <Text variant="smallCaps">Account Id</Text>
              </TableCell>
              <TableCell width="35%">
                <Text variant="smallCaps">Name</Text>
              </TableCell>
            </TableRow>
          </TableHeader>
          <TableBody>
            {institution.Accounts.map(({ ExternalAccountId, AccountName }) => (
              <TableRow key={ExternalAccountId}>
                <TableCell width="65%">
                  <Text fontWeight={500} color="neutral.700">
                    {ExternalAccountId}
                  </Text>
                </TableCell>
                <TableCell width="35%">
                  <Text fontWeight={500} color="neutral.700">
                    {AccountName}
                  </Text>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </TableWrapper>
      </ModalBody>
    </Modal>
  );
};
